const faviconsContext = require.context(
  '!!file-loader?name=favicons/[name].[ext]!.',
  true,
  /\.(png|svg|ico|xml|webmanifest)$/
)

faviconsContext.keys().forEach(faviconsContext)
